import * as e from "./index328.mjs";
import { getAugmentedNamespace as r } from "./index135.mjs";
const o = /* @__PURE__ */ r(e);
export {
  o as default
};
